import { useState, useEffect } from 'react';
import { getStore } from '@/lib/store';
import type { SiteSettings } from '@/types/db';

// Live site settings from the Supabase-hydrated store; re-renders on admin saves.
export function useSettings(): SiteSettings | null {
  const [settings, setSettings] = useState<SiteSettings | null>(getStore().settings);

  useEffect(() => {
    const handler = () => setSettings(getStore().settings);
    handler(); // sync once in case the store hydrated after mount
    window.addEventListener('admin-content-updated', handler);
    window.addEventListener('admin-data-updated', handler);
    return () => {
      window.removeEventListener('admin-content-updated', handler);
      window.removeEventListener('admin-data-updated', handler);
    };
  }, []);

  return settings;
}
